import { map, first } from 'rxjs/operators';
import { DwOperationInfoListService } from '../../../program-info/operation-info-list.service';
var DwTabRouteConfigService = /** @class */ (function () {
    function DwTabRouteConfigService(operationInfoListService, tabRouteConfigJson) {
        this.operationInfoListService = operationInfoListService;
        this.tabRouteConfigJson = tabRouteConfigJson;
    }
    DwTabRouteConfigService.prototype.newConfig = function (info, option) {
        var _option = {
            id: '',
            menuId: '',
            name: '',
            routerLink: '',
            type: ''
        };
        if (info) {
            _option = Object.assign(_option, option);
            _option.routerLink = info.routerLink;
            _option.type = info.type;
        }
        return _option;
    };
    Object.defineProperty(DwTabRouteConfigService.prototype, "routeConfigInfos$", {
        get: function () {
            var _this = this;
            return this.operationInfoListService.operationListMap$.pipe(map(function (operationListMapResp) {
                var tabRouteConfig = [];
                var operationListMap = {};
                if (operationListMapResp !== null) {
                    operationListMap = Object.assign({}, operationListMapResp);
                    _this.tabRouteConfigJson.forEach(function (tabRouteConfigJsonItem) {
                        var id = tabRouteConfigJsonItem.id;
                        var newConfig = _this.newConfig(operationListMap[id], tabRouteConfigJsonItem);
                        if (newConfig.id !== '') {
                            tabRouteConfig.push(newConfig);
                        }
                    });
                }
                return {
                    'tabRouteConfig': tabRouteConfig,
                    'operationListMap': operationListMap
                };
            }), first());
        },
        enumerable: true,
        configurable: true
    });
    return DwTabRouteConfigService;
}());
export { DwTabRouteConfigService };
